import { WizardComponent } from "ng2-archwizard";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { MovingDirection } from "ng2-archwizard";

import { CommerceService } from "../../core/service/app/commerce.service";
import { AccountService } from "../../core/service/app/account.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../store/app-state";
import { FacebookService } from "ngx-facebook";
import { DialogService } from "ng2-bootstrap-modal";
import { ToastrService } from "ngx-toastr";
import { RouterService } from "app/core/service/core/router.sevice";
import swal from "sweetalert2";
import { loadingService } from "app/core/service/loading.service";
import { DebugContext } from "@angular/core/src/view";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: "sat-home-page",
  templateUrl: "./sat-page.component.html",
  styleUrls: ["./sat-page.component.scss"]
})
export class SatPageComponent implements OnInit
{
  commerceName = "";
  rfc = "";
  ciec = "";
  confirmCiec = "";
  idSat = 0;
  wizardId = 0;

  commerceSat = { ciec : "", validado : false, exportado : false  };

  private sub: any;
  
  constructor(
    private commerceService: CommerceService,
    private loadingservice: loadingService,
    private activateRoute: ActivatedRoute,
    private route: RouterService

  ) {
    
  }

  getWizard(userID)
  {
    this.commerceService.getWizard(userID).then(result => {
      if (result != null) {
        this.commerceSat = result.commerceSat;

        if(this.commerceSat.validado == true && this.commerceSat.exportado == true)
        {
          swal({ title: "Datos Completos", text: "Ya se hizo la validación de las credenciales del SAT, puede continuar con el proceso de su registro", type: "success" }).then(result => { this.route.go('/'); });          
        }

        this.ciec = result.commerceSat.ciec;
        this.commerceName = result.register.commerceName;
      }
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.sub = this.activateRoute.params.subscribe(params => {
      this.wizardId = params['code'];
      this.getWizard(this.wizardId);
    });
  }

  Guardar()
  {
    if(this.ciec != "")
    {
      if(this.ciec.length >= 8)
      {
        if(this.ciec == this.confirmCiec)
        {
          this.commerceSat.ciec = this.ciec;
  
          swal({
            title: 'Confirmación de Terminos',
            text: 'Acepto los términos y condiciones de Anticipa para el uso de la CIEC y como firma de autorización en medios electrónicos',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.value){
              this.commerceService.validateSatWs(this.commerceSat).then(result =>{              
                swal({ title: "Proceso completo", text: "Los procesos de validación se iniciaran, puede llevar un tiempo", type: "success" }).then(r =>{
                  this.route.go('/');
                });
              });
            }
          });
        }
        else
        {
          swal({ title: "Datos incorrectos", text: "Las contraseñas no coinciden, favor de corregir", type: "warning" });
        }
      }
      else{
        swal({ title: "Datos incorrectos", text: "El CIEC no puede ser menor a 8 caracteres", type: "warning" });
      }
    }
    else
    {
      swal({ title: "Datos incompletos", text: "Favor de escribir el CIEC", type: "warning" });
    }

    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/page/sat-page/sat-page.component.ts